
export enum MapActionType {
  LAYERINFO_REQUEST = 'LAYERINFO_REQUEST',
  LAYERINFO_SUCESS = 'LAYERINFO_SUCESS',
  LAYERINFO_FAIL = 'LAYERINFO_FAIL',
  VIEW_INIT = 'VIEW_INIT',
  VIEWDIV_INIT = 'VIEWDIV_INIT',
  DISPLAY_FEATURETABLE='DISPLAY_FEATURETABLE'
};